import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import EmailProjectPage from 'components/pages/EmailProjectPage';

export default function EmailProjectApp({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <EmailProjectPage {...wrappedProps} />
    </AppWrapper>
  );
}
